// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"beq_a bhl_bk bhl_bl bhl_bo","SwipeLeftToClose--animating":"beq_b"};